import React from 'react';
import { useParams } from 'react-router-dom';

import { getAssignmentStrategy, isViewMode } from '../../constants';
import { useExperimentContext } from '../../contexts/experiment-context';
import { toPlannerExperiment } from '../overlapping-experiment';
import Abort from './abort';
import Approve from './approve';
import Clone from './clone';
import Edit from './edit';
import Reject from './reject';
import SupersetButton from './superset-button';
import { buildAccessTargetsFromVariables } from '@/utils/accessControl';

const Footer = () => {
  const params = useParams<{ action: string }>();
  const { action } = params;
  const readOnly = isViewMode(action);

  const experimentContext = useExperimentContext();
  const {
    experiment,
    adaptiveExperiment,
    variableTechFamilies,
    configurations,
    variables,
  } = experimentContext;

  if (!readOnly) return null;

  const plannerExperiment = toPlannerExperiment(experiment);
  const accessTargets = buildAccessTargetsFromVariables(variables);

  return (
    <>
      <SupersetButton />
      <div style={{ display: 'flex', gap: 8 }}>
        <Abort
          experiment={experiment}
          adaptiveExperiment={adaptiveExperiment}
          variableTechFamilies={variableTechFamilies}
          accessTargets={accessTargets}
        />
        <Reject
          experiment={plannerExperiment}
          adaptiveExperiment={adaptiveExperiment}
          variableTechFamilies={variableTechFamilies}
          accessTargets={accessTargets}
        />
        <Approve
          experiment={plannerExperiment}
          adaptiveExperiment={adaptiveExperiment}
          variableTechFamilies={variableTechFamilies}
          accessTargets={accessTargets}
        />
        <Clone
          experiment={experiment}
          adaptiveExperiment={adaptiveExperiment}
          variableTechFamilies={variableTechFamilies}
          experimentStrategy={getAssignmentStrategy(configurations)}
          accessTargets={accessTargets}
        />
        <Edit
          experiment={experiment}
          adaptiveExperiment={adaptiveExperiment}
          variableTechFamilies={variableTechFamilies}
          accessTargets={accessTargets}
        />
      </div>
    </>
  );
};

export default Footer;
